var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinning01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 299.37,
    cy: 515.8,
    r: 0.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#c6c4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#beb5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b19dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9f7cb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#976db2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 129.14,
    cy: 365.82,
    r: 42.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a78ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#976db2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 471.06,
    cy: 360.82,
    r: 42.41,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 157.02,
    cy: 176.53,
    r: 66.45,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 299.81,
    cy: 130.48,
    r: 24.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#c3bfc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b4a3bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9c75b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#976db2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 411.79,
    cy: 425.11,
    r: 47,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 302.79,
    cy: 11.24,
    r: 121.18,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 302.79,
    cy: 19.03,
    r: 102.18,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 302.79,
    cy: 26.55,
    r: 91.02,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 302.79,
    cy: 588.76,
    r: 121.18,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 302.79,
    cy: 580.97,
    r: 102.18,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 302.79,
    cy: 573.45,
    r: 91.02,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 273.03,
    cy: 373.22,
    r: 36.38,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 319.93,
    cy: 373.22,
    r: 36.38,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 296.48,
    cy: 281.85,
    r: 80.98,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 296.48,
    cy: 281.85,
    r: 67.68,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 296.48,
    cy: 281.85,
    r: 59.16,
    gradientTransform: "translate(126.55 -90.26) rotate(21.9)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 130.15,
    y1: 189.25,
    x2: 160.64,
    y2: 189.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a00e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9801ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9107ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8610f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#751cf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#632aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6328f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6224da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#611dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#601370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5f0623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 90.87,
    y1: 240.39,
    x2: 100.63,
    y2: 212.06,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7800a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7300ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6700c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5d00d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5700e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5300e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5200e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5405ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6c3bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7b5dfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#816aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8062ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7e58ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7e55ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8f49ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9a42ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9e3fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9b3cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9131ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8020ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6808ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6100ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 94.89,
    y1: 224.97,
    x2: 100.18,
    y2: 220.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 128.36,
    y1: 190.75,
    x2: 131.87,
    y2: 182.81,
    gradientTransform: "translate(27.63 -12.35) rotate(3.69)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 149.37,
    y1: 235.91,
    x2: 181.48,
    y2: 223.9,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 162.43,
    y1: 228.5,
    x2: 180.83,
    y2: 236,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 171.67,
    y1: 220.93,
    x2: 165.61,
    y2: 239.57,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 169.11,
    y1: 219.74,
    x2: 161.43,
    y2: 243.37,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4a4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 109.21,
    y1: 197.07,
    x2: 99.55,
    y2: 226.8,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 107.37,
    y1: 193.91,
    x2: 100.09,
    y2: 216.33,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bababa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 143.85,
    y1: 172.29,
    x2: 168.59,
    y2: 172.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 105.84,
    y1: 199.53,
    x2: 98.6,
    y2: 220.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 137.25,
    y1: 175.49,
    x2: 146.9,
    y2: 175.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 102.58,
    y1: 198.74,
    x2: 96.11,
    y2: 219.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 93.44,
    y1: 209.84,
    x2: 92.51,
    y2: 218.75,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba7fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b77cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b071f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a260ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9047e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7828d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e05c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 91.63,
    y1: 209.8,
    x2: 88.78,
    y2: 219.73,
    gradientTransform: "translate(84.84 -51.44) rotate(8.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 414.16,
    cy: 427.22,
    r: 62.21,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 410.85,
    cy: 323.26,
    r: 108.55,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 414.16,
    cy: 212.65,
    r: 11.77,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 481.35,
    cy: 266.19,
    r: 9.88,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 539.51,
    cy: 255.65,
    r: 9.29,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 346.89,
    cy: 266.19,
    r: 9.88,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 288.76,
    cy: 255.65,
    r: 9.29,
    gradientTransform: "translate(176.15 201.18) scale(0.29 0.23)",
    xlinkHref: "#radial-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "winning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.36 515.79 299.38 515.8 299.36 515.79 299.36 515.79",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.25,406.46H85.34l37.72-42.36L85,325.18h75.63ZM94.63,402.3h73.76L157.1,329.35H94.93L128.76,364Z",
    style: {
      fill: "url(#radial-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,128.17a4.1,4.1,0,1,0-4.09,4.11A4.08,4.08,0,0,0,271.88,128.17Z",
    style: {
      fill: "#ccc",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,128.17a4.1,4.1,0,0,0,4.09,4.11v-8.2A4.09,4.09,0,0,0,296,128.17Z",
    style: {
      fill: "#ccc",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,133h-2.89a13.65,13.65,0,0,1-26.76,0H265l12.3,41H300.1V133Z",
    style: {
      fill: "#ccc",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.92 418.23 163.25 181.29 267.94 162.54 266.16 156.62 156.26 176.31 194.23 421.66 299.32 499.76 299.32 492.15 199.92 418.23",
    style: {
      fill: "#ccc",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.88 425.49 148.45 170.73 264.18 150 262.82 145.47 143.11 166.91 183.38 427.15 183.53 428.11 299.32 514.04 299.32 508.31 187.88 425.49",
    style: {
      fill: "#ccc",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.87,401.46H427l12.58-81.28h75.63l-38,38.92Zm-83.05-4.16h73.76L471.45,359l33.82-34.62H443.11Z",
    style: {
      fill: "url(#radial-gradient-3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.2,128.17a4.09,4.09,0,0,0-4.1-4.09v8.2A4.1,4.1,0,0,0,304.2,128.17Z",
    style: {
      fill: "#9f9f9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,143.88A13.68,13.68,0,0,1,303.15,133h-3v41H323l12.29-41h-5.4A13.66,13.66,0,0,1,316.54,143.88Z",
    style: {
      fill: "#9f9f9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.42,132.28a4.1,4.1,0,1,0-4.1-4.11A4.1,4.1,0,0,0,332.42,132.28Z",
    style: {
      fill: "#9f9f9f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "299.38 499.79 405.99 421.62 443.95 176.31 334.13 156.63 332.35 162.56 436.96 181.29 400.3 418.17 299.38 492.15 299.38 492.15 299.38 499.79",
    style: {
      fill: "#9f9f9f",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.47 145.49 336.11 150.01 451.76 170.73 412.34 425.48 299.35 508.34 299.32 508.31 299.32 514.04 299.35 514.07 416.68 428.11 457.1 166.91 337.47 145.49",
    style: {
      fill: "#9f9f9f",
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.47,176.53A66.45,66.45,0,1,1,157,110.08,66.45,66.45,0,0,1,223.47,176.53Z",
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,130.48a24.34,24.34,0,1,1-24.34-24.34A24.34,24.34,0,0,1,324.15,130.48Z",
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.79,
    cy: 425.11,
    r: 47,
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.51 50.07 306.94 47.66 301.23 35.13 294.75 47.31 281.03 48.87 290.61 58.8 287.88 72.3 300.26 66.27 312.27 73.06 310.35 59.4 320.51 50.07",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.87 77.87 392.77 75.82 387.6 64.65 381.92 75.53 369.7 77 378.28 85.78 375.91 97.82 386.94 92.38 397.65 98.39 395.88 86.22 404.87 77.87",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.33 77.87 207.42 75.82 212.59 64.65 218.29 75.53 230.49 77 221.89 85.78 224.29 97.82 213.26 92.38 202.54 98.39 204.31 86.22 195.33 77.87",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.88 550.48 305.05 552.23 300.92 561.29 296.23 552.48 286.3 551.35 293.23 544.16 291.26 534.4 300.22 538.76 308.91 533.85 307.52 543.73 314.88 550.48",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.93 530.36 367.17 531.85 363.43 539.93 359.31 532.06 350.47 531 356.68 524.64 354.97 515.93 362.94 519.86 370.7 515.52 369.42 524.32 375.93 530.36",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.28 530.36 233.03 531.85 236.77 539.93 240.9 532.06 249.72 531 243.5 524.64 245.24 515.93 237.25 519.86 229.5 515.52 230.78 524.32 224.28 530.36",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.42,
    y: 9.53,
    width: 342.74,
    height: 3.43,
    style: {
      fill: "url(#radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.3,
    y: 17.4,
    width: 288.98,
    height: 3.25,
    style: {
      fill: "url(#radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.09,
    y: 25.1,
    width: 257.41,
    height: 2.9,
    style: {
      fill: "url(#radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.42,
    y: 587.04,
    width: 342.74,
    height: 3.43,
    style: {
      fill: "url(#radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.3,
    y: 579.35,
    width: 288.98,
    height: 3.25,
    style: {
      fill: "url(#radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.09,
    y: 572,
    width: 257.41,
    height: 2.9,
    style: {
      fill: "url(#radial-gradient-12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.35 413.16 268.19 389.63 240.6 400.57 258.72 333.28 305.47 345.87 287.35 413.16",
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.62 413.16 324.78 389.63 352.37 400.57 334.25 333.28 287.5 345.87 305.62 413.16",
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.28,281.85c0,8.28-13.19,14.37-15.61,21.83-2.52,7.74,4.48,20.4-.2,26.84s-19,3.74-25.48,8.47-8.18,19.11-15.92,21.62c-7.46,2.43-17.31-8.14-25.59-8.14s-18.12,10.57-25.59,8.14c-7.73-2.51-9.47-16.93-15.91-21.62s-20.74-2-25.48-8.47,2.31-19.1-.2-26.84c-2.42-7.46-15.61-13.55-15.61-21.83S226.88,267.49,229.3,260c2.51-7.74-4.49-20.4.2-26.84s19-3.73,25.48-8.47,8.18-19.1,15.91-21.62c7.47-2.42,17.32,8.14,25.59,8.14s18.13-10.56,25.59-8.14c7.74,2.52,9.48,16.94,15.92,21.62s20.74,2,25.48,8.47-2.32,19.1.2,26.84C366.09,267.49,379.28,273.58,379.28,281.85Z",
    style: {
      fill: "url(#radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.48,
    cy: 281.85,
    r: 67.68,
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.48,
    cy: 281.85,
    r: 59.16,
    transform: "translate(-83.75 130.96) rotate(-21.9)",
    style: {
      mixBlendMode: "color-dodge",
      fill: "url(#radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.48,
    cy: 281.85,
    r: 57.94,
    transform: "translate(-29.74 528.67) rotate(-80.66)",
    style: {
      fill: "#252122"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.48 312.68 299.11 318 304.98 318.85 300.73 323 301.74 328.85 296.48 326.08 291.23 328.85 292.23 323 287.98 318.85 293.86 318 296.48 312.68",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.04 309.76 274.9 313.54 279.07 314.15 276.05 317.09 276.76 321.25 273.04 319.28 269.3 321.25 270.02 317.09 267 314.15 271.17 313.54 273.04 309.76",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.93 309.76 318.07 313.54 313.9 314.15 316.92 317.09 316.2 321.25 319.93 319.28 323.66 321.25 322.95 317.09 325.97 314.15 321.8 313.54 319.93 309.76",
    style: {
      fill: "#969696"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.22,186.33S146,198.1,138.8,198.07c1-2.76-2-6.29-5.75-6,.27-1.33,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,186.32s-12.11,11.42-19.35,11.73c.9-2.59-1.78-6.37-5.81-6,.16-1.25,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#f8f6f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,186.31s-12,11.07-19.27,11.72c.76-2.43-1.54-6.46-5.88-6,0-1.17,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#f1edf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,186.31S146.33,197,139,198a5.11,5.11,0,0,0-5.94-6c-.06-1.09,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#eae4ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,186.3s-11.74,10.35-19.14,11.7a5.08,5.08,0,0,0-6-5.93c-.17-1,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#e2dce6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.18,186.29s-11.61,10-19.07,11.69c.38-2-.77-6.72-6.06-5.91-.28-.92,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#dbd3e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,186.28s-11.48,9.65-19,11.69c.25-1.81-.51-6.81-6.12-5.9-.39-.84,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#d4cada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,186.27s-11.35,9.3-18.93,11.68c.13-1.64-.26-6.89-6.18-5.88-.5-.76,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#cdc1d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.15,186.26s-11.22,9-18.86,11.67c0-1.48,0-7-6.24-5.86-.61-.68,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#c6b8ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.15,186.25s-11.1,8.6-18.79,11.67c-.14-1.33.25-7.07-6.31-5.85-.72-.6,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#bfafc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.14,186.24s-11,8.25-18.72,11.66c-.27-1.17.5-7.16-6.37-5.83-.83-.52,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#b8a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.13,186.23s-10.84,7.89-18.65,11.65c-.39-1,.76-7.24-6.43-5.81-.94-.44,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#b19dbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,186.22a208.59,208.59,0,0,1-18.58,11.65c-.52-.86,1-7.33-6.49-5.8-1.05-.35,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#a995b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.11,186.21s-10.58,7.19-18.51,11.64c-.65-.69,1.27-7.42-6.55-5.78-1.16-.27,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#a28caf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,186.2s-10.46,6.84-18.44,11.63c-.77-.53,1.53-7.5-6.61-5.76-1.27-.19,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#9b83a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,186.19s-10.34,6.49-18.38,11.63c-.9-.38,1.78-7.59-6.67-5.75-1.38-.11,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#947aa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.09,186.18s-10.21,6.14-18.3,11.62c-1-.22,2-7.68-6.74-5.73-1.49,0,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#8d719d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,186.18S148,192,139.85,197.78c-1.17-.06,2.28-7.76-6.8-5.71-1.6.05,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#866897"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,186.17a173.39,173.39,0,0,0-18.16,11.6c-1.29.09,2.54-7.86-6.86-5.7-1.71.13,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#7f5f91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,186.16A129.82,129.82,0,0,0,140,197.75c-1.42.26,2.8-7.94-6.92-5.68-1.82.22,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#78568b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,186.15a103.67,103.67,0,0,0-18,11.59c-1.55.41,3.05-8-7-5.67-1.93.3,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#704e84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,186.14a86.1,86.1,0,0,0-18,11.58c-1.67.57,3.31-8.12-7-5.65-2,.38,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#69457e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,186.13a73.44,73.44,0,0,0-17.89,11.57c-1.8.73,3.56-8.2-7.1-5.63-2.14.46,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#623c78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,186.12a63.63,63.63,0,0,0-17.81,11.57c-1.94.88,3.81-8.29-7.17-5.62-2.25.54,19.85-9.9,19.85-9.9Z",
    style: {
      fill: "#5b3372"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6,157.93c4,2.28,25.17,11.08,54.48,24.74A352.57,352.57,0,0,1,189,206.35c11.29,7.33,18.88,12.91,19.72,13.21,7.38,2.6,15.84-.24,16.61-3.69,1.59-7.14-15.59-8.92-36.33-20.27-17.19-9.41-37-21-53.64-30.35s-30-16.36-34.34-16.6C92.77,148.18,83.76,152.88,92.6,157.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,148.7c-7.58-.44-15.57,3.55-9.91,8.08a13.84,13.84,0,0,0,1.79,1.2c4,2.28,24.38,10.82,52.13,23.73l2.07,1a342.76,342.76,0,0,1,36,19.87q3,1.89,5.76,3.67c11.08,7.17,18.59,12.7,19.66,13.12a17.77,17.77,0,0,0,6.47,1.1c5,0,9.42-2.29,10-4.72,1.6-6.92-15.48-9-36.14-20.36-6.52-3.58-13.43-7.46-20.39-11.41-11.34-6.44-22.84-13-33.12-18.78C118.73,155.92,105.36,149,101,148.7Z",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.08,148.76c-7.61-.46-15.34,3.56-9.65,8.08A13.89,13.89,0,0,0,93.22,158c4.16,2.34,24.59,11,51.86,23.7l2.07,1A351.8,351.8,0,0,1,183,202.45c2,1.24,3.92,2.46,5.74,3.63,10.87,7,18.31,12.49,19.6,13a17.47,17.47,0,0,0,6.4,1.2c4.94.09,9.32-2.32,9.9-4.74,1.61-6.7-15.37-9.15-36-20.45-6.5-3.57-13.38-7.44-20.33-11.37-11.3-6.4-22.78-13-33-18.65C118.75,155.93,105.4,149,101.08,148.76Z",
    style: {
      fill: "#f2f3f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.12,148.82c-7.63-.49-15.12,3.58-9.37,8.08a14.48,14.48,0,0,0,1.78,1.17c4.28,2.39,24.81,11.14,51.59,23.66l2.06,1a360.38,360.38,0,0,1,35.68,19.64q3,1.86,5.73,3.61c10.66,6.86,18,12.27,19.53,12.93a17.23,17.23,0,0,0,6.33,1.3c4.84.19,9.22-2.35,9.82-4.76,1.62-6.48-15.27-9.26-35.8-20.55-6.47-3.55-13.33-7.41-20.26-11.32-11.28-6.36-22.73-12.88-33-18.53C118.76,155.93,105.44,149.1,101.12,148.82Z",
    style: {
      fill: "#ececed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,148.88c-7.66-.51-14.9,3.61-9.11,8.07a13.45,13.45,0,0,0,1.78,1.16c4.41,2.46,25,11.3,51.33,23.64l2,1a370.76,370.76,0,0,1,35.54,19.53c2,1.22,3.89,2.42,5.71,3.58,10.45,6.7,17.74,12,19.46,12.83a17.54,17.54,0,0,0,6.27,1.4c4.74.29,9.11-2.38,9.73-4.78,1.63-6.26-15.16-9.38-35.61-20.64-6.45-3.55-13.29-7.39-20.21-11.28-11.24-6.33-22.67-12.8-32.89-18.4C118.77,155.93,105.48,149.17,101.17,148.88Z",
    style: {
      fill: "#e6e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,148.94c-7.69-.53-14.68,3.63-8.84,8.07a14.64,14.64,0,0,0,1.78,1.14c4.54,2.52,25.23,11.47,51.06,23.61l2,1a383.06,383.06,0,0,1,35.39,19.41q3,1.83,5.69,3.55c10.26,6.53,17.45,11.83,19.4,12.74a18,18,0,0,0,6.2,1.5c4.64.39,9-2.41,9.65-4.8,1.63-6.05-15.06-9.5-35.44-20.73-6.42-3.54-13.25-7.37-20.14-11.24-11.21-6.29-22.62-12.72-32.82-18.28C118.79,155.93,105.52,149.23,101.21,148.94Z",
    style: {
      fill: "#e0e0e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,149c-7.72-.55-14.47,3.65-8.57,8.07a14.57,14.57,0,0,0,1.77,1.13c4.67,2.57,25.45,11.62,50.8,23.57l2,1A392.77,392.77,0,0,1,182.53,202c2,1.2,3.86,2.37,5.67,3.52,10.05,6.37,17.17,11.6,19.34,12.65a18.54,18.54,0,0,0,6.13,1.59c4.54.49,8.9-2.44,9.56-4.81,1.63-5.84-14.95-9.62-35.26-20.84-6.4-3.53-13.2-7.33-20.08-11.18-11.18-6.27-22.56-12.64-32.74-18.16C118.8,155.94,105.56,149.3,101.26,149Z",
    style: {
      fill: "#d9dada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,149.06c-7.74-.58-14.24,3.68-8.3,8.07a16.12,16.12,0,0,0,1.77,1.11c4.8,2.64,25.66,11.78,50.53,23.55l2,1c12.7,6.07,24.82,12.93,35.11,19.18,2,1.2,3.84,2.36,5.65,3.5,9.85,6.2,16.89,11.37,19.28,12.55a19.15,19.15,0,0,0,6.07,1.7c4.43.58,8.78-2.48,9.47-4.84,1.63-5.62-14.84-9.74-35.08-20.93-6.38-3.52-13.16-7.31-20-11.14-11.15-6.23-22.51-12.56-32.67-18C118.82,155.94,105.6,149.37,101.3,149.06Z",
    style: {
      fill: "#d3d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,149.12c-7.77-.6-14,3.7-8,8.07a18,18,0,0,0,1.77,1.1C100,161,121,170.23,145.34,181.8l2,1c12.64,6.06,24.69,12.85,35,19.06,1.95,1.18,3.84,2.33,5.64,3.46,9.64,6.05,16.62,11.14,19.22,12.46a20.11,20.11,0,0,0,6,1.8c4.32.67,8.68-2.51,9.39-4.86,1.62-5.4-14.74-9.85-34.91-21-6.35-3.52-13.11-7.29-19.95-11.1-11.12-6.19-22.46-12.48-32.6-17.91C118.83,155.94,105.64,149.44,101.35,149.12Z",
    style: {
      fill: "#cdcdce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,149.18c-7.79-.62-13.81,3.73-7.76,8.06a15.72,15.72,0,0,0,1.76,1.09c5,2.75,26.09,12.1,50,23.48l2,1c12.59,6,24.56,12.78,34.81,18.95,1.94,1.16,3.82,2.31,5.62,3.43,9.44,5.89,16.34,10.91,19.16,12.36a21.21,21.21,0,0,0,5.93,1.9c4.22.77,8.57-2.54,9.3-4.88,1.62-5.18-14.63-10-34.73-21.11l-19.89-11.06c-11.09-6.16-22.4-12.4-32.52-17.78C118.84,155.94,105.68,149.51,101.39,149.18Z",
    style: {
      fill: "#c7c7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,149.24c-7.83-.64-13.6,3.75-7.5,8.06a17.52,17.52,0,0,0,1.76,1.08c5.18,2.8,26.3,12.25,49.73,23.44l2,1c12.53,6.05,24.43,12.7,34.67,18.83,1.93,1.16,3.81,2.29,5.6,3.41,9.23,5.73,16.06,10.67,19.1,12.27a22.44,22.44,0,0,0,5.86,2c4.12.86,8.46-2.57,9.22-4.9,1.61-5-14.53-10.09-34.55-21.21-6.31-3.49-13-7.24-19.83-11C156.42,176,145.13,169.84,135,164.5,118.86,156,105.72,149.58,101.44,149.24Z",
    style: {
      fill: "#c0c1c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,149.3c-7.85-.67-13.38,3.78-7.23,8.06A18.7,18.7,0,0,0,96,158.42c5.31,2.86,26.52,12.42,49.47,23.42l2,.95c12.47,6.05,24.3,12.63,34.52,18.72,1.92,1.14,3.79,2.27,5.59,3.38,9,5.57,15.78,10.43,19,12.17a24.13,24.13,0,0,0,5.8,2.09c4,.95,8.35-2.6,9.13-4.92,1.6-4.75-14.42-10.2-34.37-21.3-6.28-3.49-13-7.22-19.77-11-11-6.09-22.29-12.24-32.37-17.54C118.87,156,105.76,149.65,101.48,149.3Z",
    style: {
      fill: "#babbbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,149.36c-7.88-.69-13.17,3.81-7,8.06a17.25,17.25,0,0,0,1.74,1c5.45,2.92,26.74,12.58,49.21,23.39l2,1c12.42,6,24.17,12.55,34.38,18.6,1.91,1.14,3.77,2.25,5.57,3.35,8.81,5.42,15.51,10.19,19,12.08a25.9,25.9,0,0,0,5.73,2.19c3.92,1,8.24-2.63,9-4.94,1.58-4.54-14.31-10.32-34.2-21.39-6.25-3.48-12.93-7.19-19.7-10.92-11-6.06-22.23-12.16-32.3-17.41C118.88,156,105.8,149.72,101.53,149.36Z",
    style: {
      fill: "#b4b5b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57,149.41c-7.9-.7-12.95,3.85-6.69,8.07.42.28,1,.63,1.74,1,5.58,3,26.95,12.74,48.94,23.35l1.95.95c12.36,6,24.05,12.48,34.24,18.49,1.9,1.12,3.76,2.23,5.55,3.32,8.6,5.26,15.24,9.95,18.9,12a28.23,28.23,0,0,0,5.66,2.29c3.82,1.13,8.13-2.66,9-5,1.57-4.32-14.2-10.43-34-21.48-6.24-3.48-12.89-7.17-19.65-10.88-11-6-22.17-12.08-32.21-17.29C118.9,156,105.84,149.79,101.57,149.41Z",
    style: {
      fill: "#aeaeb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.62,149.47c-7.94-.72-12.74,3.88-6.43,8.06a20,20,0,0,0,1.74,1c5.71,3,27.17,12.9,48.68,23.32l1.94.95c12.3,6,23.91,12.41,34.09,18.37,1.89,1.12,3.74,2.21,5.53,3.3,8.39,5.1,15,9.7,18.84,11.89a30.75,30.75,0,0,0,5.59,2.38c3.72,1.22,8-2.69,8.88-5,1.55-4.11-14.1-10.55-33.84-21.58-6.21-3.46-12.85-7.14-19.58-10.83-10.93-6-22.12-12-32.14-17.16C118.91,156,105.88,149.86,101.62,149.47Z",
    style: {
      fill: "#a7a8aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,149.53c-8-.75-12.53,3.91-6.15,8.06.41.27,1,.61,1.73,1,5.84,3.09,27.38,13.05,48.41,23.29l1.93.94c12.25,6,23.78,12.33,33.95,18.26,1.88,1.1,3.73,2.19,5.51,3.26,8.19,5,14.7,9.46,18.78,11.8a35.76,35.76,0,0,0,5.52,2.49c3.62,1.29,7.91-2.73,8.8-5,1.52-3.9-14-10.68-33.67-21.68-6.18-3.46-12.8-7.12-19.52-10.79-10.9-5.95-22.06-11.91-32.06-17C118.93,156,105.92,149.93,101.66,149.53Z",
    style: {
      fill: "#a1a2a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,149.59c-8-.77-12.32,3.94-5.89,8.06.4.26,1,.6,1.73,1,6,3.15,27.59,13.22,48.15,23.26l1.91.94c12.2,6,23.66,12.26,33.81,18.15,1.88,1.09,3.71,2.16,5.49,3.23,8,4.79,14.43,9.21,18.72,11.7a40.12,40.12,0,0,0,5.45,2.59c3.52,1.37,7.79-2.76,8.71-5,1.5-3.69-13.88-10.79-33.48-21.77-6.16-3.45-12.76-7.1-19.46-10.75-10.87-5.91-22-11.83-32-16.91C118.94,156,106,150,101.71,149.59Z",
    style: {
      fill: "#9b9c9e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75,149.65c-8-.79-12.11,4-5.61,8.06.39.25,1,.58,1.72,1,6.11,3.2,27.81,13.38,47.88,23.23l1.91,1c12.13,6,23.52,12.18,33.65,18q2.82,1.62,5.48,3.21c7.77,4.63,14.17,8.95,18.66,11.6a45.86,45.86,0,0,0,5.39,2.69c3.41,1.46,7.67-2.79,8.62-5,1.47-3.48-13.78-10.91-33.31-21.86-6.14-3.45-12.71-7.08-19.39-10.7-10.84-5.89-22-11.76-31.92-16.79C119,156,106,150.07,101.75,149.65Z",
    style: {
      fill: "#959697"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,149.71c-8-.81-11.9,4-5.35,8,.39.25,1,.57,1.72,1,6.24,3.25,28,13.54,47.61,23.19l1.9,1c12.08,6,23.4,12.1,33.51,17.91,1.87,1.07,3.69,2.12,5.46,3.17,7.56,4.49,13.9,8.7,18.59,11.52a58,58,0,0,0,5.33,2.78c3.31,1.54,7.55-2.83,8.53-5.06,1.45-3.27-13.67-11-33.13-22-6.11-3.43-12.66-7-19.33-10.65-10.81-5.85-21.9-11.68-31.84-16.67C119,156,106.05,150.13,101.8,149.71Z",
    style: {
      fill: "#8e8f91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84,149.77c-8.07-.84-11.69,4-5.08,8,.39.23,1,.56,1.72,1,6.37,3.31,28.24,13.7,47.35,23.17l1.88.94c12,6,23.27,12,33.37,17.79q2.79,1.59,5.44,3.15c7.35,4.33,13.64,8.44,18.53,11.42,1.76,1.07,3.53,2,5.26,2.88,3.22,1.62,7.43-2.86,8.45-5.08,1.41-3.06-13.57-11.14-32.95-22-6.09-3.42-12.63-7-19.27-10.61-10.78-5.81-21.85-11.59-31.77-16.54C119,156,106.09,150.2,101.84,149.77Z",
    style: {
      fill: "#88898b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,149.83c-8.1-.86-11.48,4.09-4.81,8,.37.22,1,.54,1.71.94,6.5,3.36,28.45,13.85,47.08,23.13l1.88.94c12,6,23.13,12,33.22,17.68,1.85,1.05,3.66,2.08,5.43,3.12,7.13,4.17,13.37,8.18,18.46,11.32,1.75,1.08,3.49,2.06,5.19,3,3.13,1.69,7.3-2.9,8.37-5.1,1.38-2.86-13.47-11.26-32.78-22.14-6.06-3.42-12.58-7-19.21-10.57-10.74-5.78-21.79-11.51-31.69-16.42C119,156,106.13,150.27,101.89,149.83Z",
    style: {
      fill: "#828385"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93,149.89c-8.12-.88-11.27,4.13-4.54,8.05.37.21,1,.53,1.71.92,6.63,3.42,28.66,14,46.82,23.1l1.86.94c11.91,6,23,11.88,33.08,17.56q2.76,1.56,5.41,3.09c6.92,4,13.11,7.93,18.4,11.23q2.6,1.62,5.12,3.08c3,1.77,7.18-2.94,8.28-5.12,1.35-2.65-13.35-11.37-32.6-22.23-6-3.41-12.53-7-19.14-10.53-10.72-5.74-21.74-11.43-31.62-16.29C119,156,106.17,150.34,101.93,149.89Z",
    style: {
      fill: "#7c7d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,150c-8.15-.9-11.07,4.18-4.28,8.05.37.2.94.51,1.71.9,6.75,3.48,28.88,14.18,46.55,23.07l1.86.94c11.85,6,22.87,11.81,32.93,17.45,1.83,1,3.62,2,5.39,3.06,6.71,3.88,12.86,7.66,18.34,11.14l5.05,3.17c2.94,1.85,7.05-3,8.2-5.14,1.3-2.45-13.25-11.49-32.42-22.33-6-3.4-12.49-6.95-19.09-10.47-10.68-5.72-21.68-11.36-31.54-16.17C119,156,106.21,150.41,102,150Z",
    style: {
      fill: "#757779"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,158.05c3.6,2,28.89,14.27,48,23.94,12.51,6.33,24.07,12.37,34.64,18.26s20.13,11.64,28.63,17.36c2.85,1.91,6.91-3,8.11-5.17,1.67-2.95-23.73-18.18-51.26-32.85S108.91,150.78,102,150C93.85,149.09,91.16,154.23,98,158.05Z",
    style: {
      fill: "#4f4f4f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.46,180.19a27,27,0,0,1-7.11,3.24,20.89,20.89,0,0,1-3.61.58,12.13,12.13,0,0,0-1.81.25,4.72,4.72,0,0,0-1.28.55,13.65,13.65,0,0,0-3.43,3.35,10.8,10.8,0,0,1-5,3.47c-.05,0,0,.23,0,.22,3.35,1.77,6.08-.81,8.41-.08,1.89.6.48,4.74-.72,6.22,0,0,0,.19,0,.23-.2.22,2.67.05,3.88-.51,2-.89,2.92-2.39,4.09-4.12a18.7,18.7,0,0,1,3.27-3.88,4.83,4.83,0,0,1,1.14-.71,8.63,8.63,0,0,1,1.55-.47,17.41,17.41,0,0,0,3.06-1c2.25-1,3.94-2.75,5.83-4.31C157.8,182.11,155.29,181.28,152.46,180.19Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.94,178.77s-9.62,2.45-9.84,3.95c-.36,2.49,6.6,4.83,9,4.09s8.66-4.48,8.66-4.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.8s-9.37,2.4-9.61,3.83c-.41,2.44,6.45,4.75,8.82,4s8.58-4.34,8.58-4.34Z",
    style: {
      fill: "#fdfcfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.82s-9.11,2.36-9.38,3.73c-.45,2.38,6.3,4.65,8.63,4s8.51-4.2,8.51-4.2Z",
    style: {
      fill: "#fcfafd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.85s-8.86,2.31-9.14,3.62c-.51,2.32,6.14,4.56,8.44,3.92s8.42-4.06,8.42-4.06Z",
    style: {
      fill: "#faf7fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.87s-8.6,2.27-8.9,3.51c-.56,2.28,6,4.48,8.25,3.88s8.35-3.93,8.35-3.93Z",
    style: {
      fill: "#f9f4fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.9s-8.35,2.22-8.67,3.4c-.61,2.23,5.84,4.38,8.07,3.82s8.27-3.79,8.27-3.79Z",
    style: {
      fill: "#f7f2fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,178.92s-8.1,2.18-8.44,3.3c-.66,2.18,5.69,4.29,7.89,3.76s8.18-3.66,8.18-3.66Z",
    style: {
      fill: "#f5effa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179s-7.86,2.14-8.21,3.18c-.71,2.15,5.54,4.2,7.7,3.72s8.11-3.53,8.11-3.53Z",
    style: {
      fill: "#f4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179s-7.62,2.1-8,3.08c-.77,2.1,5.39,4.11,7.52,3.66s8-3.39,8-3.39Z",
    style: {
      fill: "#f2e9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179s-7.36,2.05-7.73,3c-.83,2.06,5.23,4,7.33,3.6s7.94-3.25,7.94-3.25Z",
    style: {
      fill: "#f1e7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179s-7.13,2-7.5,2.86c-.89,2,5.08,3.93,7.14,3.56s7.87-3.12,7.87-3.12Z",
    style: {
      fill: "#efe4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179.05s-6.89,2-7.27,2.75c-1,2,4.93,3.83,7,3.5s7.79-3,7.79-3Z",
    style: {
      fill: "#ede1f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179.07s-6.79,1.87-7,2.65c-1.35,1.74,4.78,3.74,6.78,3.44s7.7-2.85,7.7-2.85Z",
    style: {
      fill: "#ecdff4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179.1s-6.55,1.81-6.8,2.53c-1.43,1.68,4.63,3.65,6.59,3.4s7.63-2.72,7.63-2.72Z",
    style: {
      fill: "#eadcf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.05,179.12s-6.31,1.77-6.56,2.43c-1.52,1.62,4.47,3.56,6.4,3.34s7.55-2.58,7.55-2.58Z",
    style: {
      fill: "#e8d9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.06,179.15s-6.08,1.72-6.33,2.32c-1.61,1.55,4.32,3.46,6.21,3.28s7.47-2.44,7.47-2.44Z",
    style: {
      fill: "#e7d7f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,179.17s-5.85,1.67-6.1,2.21c-1.69,1.49,4.17,3.38,6,3.23s7.39-2.3,7.39-2.3Z",
    style: {
      fill: "#e5d4f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,179.2s-5.61,1.62-5.87,2.1c-1.77,1.43,4,3.28,5.85,3.18s7.31-2.17,7.31-2.17Z",
    style: {
      fill: "#e4d1ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,179.22s-5.37,1.58-5.63,2c-1.85,1.36,3.87,3.18,5.66,3.12s7.23-2,7.23-2Z",
    style: {
      fill: "#e2ceef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.09,179.25s-5.13,1.52-5.4,1.88c-1.93,1.31,3.72,3.1,5.48,3.07s7.15-1.9,7.15-1.9Z",
    style: {
      fill: "#e0ccee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,179.27s-4.86,1.52-5.16,1.78c-1.81,1.53,3.56,3,5.29,3s7.07-1.77,7.07-1.77Z",
    style: {
      fill: "#dfc9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,179.3s-4.64,1.46-4.93,1.67c-2,1.41,3.41,2.9,5.1,3s7-1.63,7-1.63Z",
    style: {
      fill: "#ddc6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,179.32s-4.41,1.4-4.69,1.56c-2.11,1.26,3.26,2.82,4.92,2.91s6.91-1.49,6.91-1.49Z",
    style: {
      fill: "#dcc4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,179.35s-4.19,1.33-4.46,1.45c-2.26,1,3.11,2.72,4.73,2.86s6.84-1.36,6.84-1.36Z",
    style: {
      fill: "#dac1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,179.36s-4.11,1.29-4.37,1.42c-2.16,1.06,3.11,2.7,4.74,2.84s6.7-1.32,6.7-1.32Z",
    style: {
      fill: "#d2b9e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.18,179.38s-4,1.25-4.29,1.38c-2,1.08,3.13,2.68,4.75,2.82s6.57-1.28,6.57-1.28Z",
    style: {
      fill: "#cab0dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22,179.39s-4,1.21-4.21,1.35c-1.93,1.09,3.13,2.65,4.75,2.81s6.44-1.26,6.44-1.26Z",
    style: {
      fill: "#c2a8d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,179.4s-3.89,1.18-4.13,1.32c-1.81,1.1,3.14,2.63,4.76,2.79s6.31-1.22,6.31-1.22Z",
    style: {
      fill: "#ba9fce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.28,179.42s-3.82,1.13-4,1.28c-1.7,1.11,3.14,2.61,4.76,2.78s6.18-1.19,6.18-1.19Z",
    style: {
      fill: "#b297c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,179.43s-3.74,1.1-3.95,1.25c-1.58,1.12,3.14,2.59,4.76,2.76s6-1.15,6-1.15Z",
    style: {
      fill: "#aa8fc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34,179.45s-3.67,1.05-3.87,1.21c-1.46,1.12,3.15,2.56,4.77,2.75s5.92-1.12,5.92-1.12Z",
    style: {
      fill: "#a286b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37,179.46s-3.59,1-3.78,1.18c-1.35,1.11,3.16,2.54,4.77,2.73s5.79-1.08,5.79-1.08Z",
    style: {
      fill: "#9a7eb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.41,179.48s-3.52,1-3.71,1.14c-1.24,1.11,3.17,2.52,4.78,2.71s5.67-1,5.67-1Z",
    style: {
      fill: "#9275ab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.44,179.49s-3.44.93-3.62,1.11c-1.13,1.1,3.17,2.5,4.78,2.7s5.54-1,5.54-1Z",
    style: {
      fill: "#8a6da4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,179.51a34.32,34.32,0,0,0-3.54,1.07c-1,1.08,3.18,2.47,4.79,2.68s5.41-1,5.41-1Z",
    style: {
      fill: "#82659d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,179.52a31.85,31.85,0,0,0-3.45,1c-.91,1.06,3.18,2.45,4.8,2.67,1.44.19,5.27-.94,5.27-.94Z",
    style: {
      fill: "#7a5c96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,179.54a23.2,23.2,0,0,0-3.37,1c-1,.89,3.19,2.44,4.81,2.66,1.43.2,5.14-.9,5.14-.9Z",
    style: {
      fill: "#72548f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,179.55a21.28,21.28,0,0,0-3.28,1c-.88.88,3.2,2.42,4.81,2.64,1.43.2,5-.86,5-.86Z",
    style: {
      fill: "#6a4c88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.59,179.56a18.83,18.83,0,0,0-3.19.93c-.78.87,3.2,2.39,4.81,2.63,1.42.2,4.88-.84,4.88-.84Z",
    style: {
      fill: "#624381"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.63,179.58a16.82,16.82,0,0,0-3.12.89c-.68.85,3.21,2.37,4.82,2.61,1.42.21,4.75-.8,4.75-.8Z",
    style: {
      fill: "#5a3b7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.66,179.59a17.3,17.3,0,0,0-3,.86c-.43.93,3.21,2.35,4.82,2.6,1.41.21,4.62-.77,4.62-.77Z",
    style: {
      fill: "#523273"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.69,179.61a15.3,15.3,0,0,0-2.95.82c-.35.89,3.22,2.33,4.83,2.58,1.41.22,4.49-.73,4.49-.73Z",
    style: {
      fill: "#4a2a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72,179.62s-2.78.53-2.86.79c-.27.86,3.23,2.3,4.83,2.56a13.89,13.89,0,0,0,4.36-.69Z",
    style: {
      fill: "#422265"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75,179.64s-2.71.48-2.78.75c-.19.83,3.24,2.28,4.84,2.55a13.17,13.17,0,0,0,4.23-.66Z",
    style: {
      fill: "#3a195e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.78,179.65s-2.65.44-2.69.72c-.12.8,3.24,2.26,4.84,2.53a12.21,12.21,0,0,0,4.1-.62Z",
    style: {
      fill: "#321157"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,179.67s-2.59.39-2.61.68c0,.78,3.25,2.24,4.85,2.52a11.61,11.61,0,0,0,4-.59Z",
    style: {
      fill: "#2a0850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.85,179.68s-2.53.35-2.53.65c0,.76,3.25,2.21,4.86,2.5a10.71,10.71,0,0,0,3.84-.55Z",
    style: {
      fill: "#220049"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.49,180a27.43,27.43,0,0,1-7.1,3.23,22.07,22.07,0,0,1-3.61.58A12.46,12.46,0,0,0,140,184a4.65,4.65,0,0,0-1.28.54,13.82,13.82,0,0,0-3.43,3.35,9.45,9.45,0,0,1-4.53,3.48c-.05,0-.53.22-.53.22,3.36,1.77,6.08-.82,8.41-.08,1.94.61.47,5.06-.75,6.44-.19.22,2.67.06,3.89-.5,2-.9,2.91-2.4,4.08-4.12a18.26,18.26,0,0,1,3.28-3.89,4.46,4.46,0,0,1,1.14-.71,9.13,9.13,0,0,1,1.54-.47,17.21,17.21,0,0,0,3.07-1c2.24-1,3.94-2.76,5.82-4.32C157.84,181.89,155.33,181.06,152.49,180Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,181.2a23.31,23.31,0,0,1-4.92,2c-.33.09-.67.16-1,.23a4.55,4.55,0,0,0,2.16.64,52.31,52.31,0,0,0,5.91-1.34Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91,182.94,139,178.89a5,5,0,0,0,.64.25,5.35,5.35,0,0,0,.69.17,5.83,5.83,0,0,0,.73.1c.25,0,.51,0,.78,0a7.57,7.57,0,0,0,1.12-.11,9.57,9.57,0,0,0,1.19-.27,11.63,11.63,0,0,0,1.26-.42c.42-.16.86-.35,1.32-.58l7.67,3.19c-.39.27-.77.52-1.13.73s-.74.41-1.08.57a8.91,8.91,0,0,1-1,.4,6.19,6.19,0,0,1-.94.24,3.58,3.58,0,0,1-.64.07,4.12,4.12,0,0,1-.61,0,5,5,0,0,1-.56-.11A3.82,3.82,0,0,1,147.91,182.94Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09,186H224c-2.86-.72-5.83-1.26-8.63-2.17L201.5,211.29q4,2.81,7.86,5.93a2,2,0,0,0,.95.43,2.79,2.79,0,0,0,1.16-.1,5.28,5.28,0,0,0,1.31-.59,11.1,11.1,0,0,0,1.46-1.08c.26-.23.53-.48.8-.74h0l0,0c.25-.25.51-.51.76-.79h0l.25-.3c.18-.19.35-.39.52-.59l0,0c.11-.12.21-.25.31-.38s.3-.36.44-.56l.05-.06,0,0,0,0,.18-.24.26-.35.26-.36,0,0,0,0,.2-.28.21-.31.21-.31.11-.16,0,0,.08-.13.21-.32.18-.29.19-.29.06-.1v0c0-.06.07-.12.11-.17l.18-.3.17-.29.17-.28a.75.75,0,0,1,.07-.12v0l0,0,.07-.11.16-.29.16-.28.16-.29.12-.21v0l0-.06.16-.29.15-.3.16-.29.15-.3.15-.29.16-.32c0-.09.1-.2.15-.31l.15-.31,0,0,0,0a2.56,2.56,0,0,1,.11-.24c.05-.12.11-.23.16-.35a3.54,3.54,0,0,0,.16-.34c.05-.11.1-.23.16-.35h0l.15-.34c.06-.14.12-.27.17-.4l.18-.41a.69.69,0,0,1,.05-.13l0-.07a1.8,1.8,0,0,0,.08-.21c.06-.13.11-.27.17-.4l.24-.61a.14.14,0,0,1,0-.06s0,0,0-.05.12-.34.19-.51l.21-.61s0-.09,0-.13a.49.49,0,0,1,0-.11l.12-.38c0-.07.05-.15.08-.22a1.87,1.87,0,0,1,.07-.22l.07-.22a1.87,1.87,0,0,1,.07-.22c.09-.3.17-.59.25-.87,0-.13.07-.25.1-.38a2.33,2.33,0,0,0,.07-.25l.06-.22c.07-.27.13-.54.19-.81l0-.11s0-.05,0-.07l.12-.54s0,0,0-.07h0l0-.13c0-.15.05-.3.08-.44v0a1.38,1.38,0,0,0,0-.2c0-.11,0-.22.06-.33V193l0-.23,0-.26a.13.13,0,0,0,0-.06s0-.05,0-.06,0-.12,0-.18a1.79,1.79,0,0,1,0-.23s0-.07,0-.11,0-.07,0-.11a.57.57,0,0,1,0-.13c0-.11,0-.23,0-.34h0v0c0-.1,0-.2,0-.29v-.14a.41.41,0,0,0,0-.11v-.08c0-.09,0-.18,0-.26v-.27c0-.08,0-.17,0-.25v-.12s0-.09,0-.14a1.8,1.8,0,0,0,0-.22.06.06,0,0,0,0,0v0s0-.09,0-.14l0-.21s0,0,0,0,0,0,0,0,0-.08,0-.13,0,0,0-.06a.13.13,0,0,0,0-.06s0,0,0-.07,0,0,0-.06l0-.12,0-.12s0-.09,0-.12l0-.11h0l-.06-.16-.06-.16s0,0,0-.07v0h0s0,0,0-.06,0-.1-.08-.14a1.09,1.09,0,0,0-.08-.15s0,0,0,0h0l-.06-.11-.1-.12a.7.7,0,0,0-.06-.09h0l0,0-.11-.12-.11-.11,0,0,0,0-.08-.07-.12-.1-.08,0h0s0,0,0,0l0,0-.15-.09-.13-.06s0,0,0,0h0l-.17-.07h-.05Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,191.54h0l-.14,0a26.92,26.92,0,0,0-2,2c0,.28-.66.27-1.29.26l-8.32,16.46a10.16,10.16,0,0,0,2.61,2.36l-.13-.07-.06,0,2.52,1.85a1.39,1.39,0,0,0,.73.3,2.18,2.18,0,0,0,.86-.08,4.37,4.37,0,0,0,1-.44,7.93,7.93,0,0,0,1.07-.76,18,18,0,0,0,2.59-2.77,34,34,0,0,0,2.42-3.62,40.51,40.51,0,0,0,2.1-4.1,34.14,34.14,0,0,0,1.61-4.3c.22-.74.4-1.45.55-2.13a16.11,16.11,0,0,0,.3-1.92,9.77,9.77,0,0,0,.06-1.68,5.79,5.79,0,0,0-.22-1.41,3.9,3.9,0,0,0-.23-.61,2.59,2.59,0,0,0-.32-.49,2.25,2.25,0,0,0-.4-.36,1.74,1.74,0,0,0-.48-.22l-1.22-.38a1.29,1.29,0,0,1-.72,0l0,0-.07,0a2.27,2.27,0,0,1,.35.49,2.27,2.27,0,0,0-.35-.49h0l-.27.16a5.46,5.46,0,0,0-.71.53S218.36,191.64,218.08,191.54Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.81,207.37q3.3,2.07,6.52,4.25a2.5,2.5,0,0,1,.07-.26c-2.13-1.44-4.3-2.84-6.49-4.2Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,208.93a28.13,28.13,0,0,0,1.88-2.85,34.84,34.84,0,0,0,1.63-3.23,26.63,26.63,0,0,0,1.23-3.35c.18-.62.32-1.2.43-1.74a13.57,13.57,0,0,0,.22-1.54,9.58,9.58,0,0,0,0-1.3,4.9,4.9,0,0,0-.2-1,2.2,2.2,0,0,0-.18-.41,2.36,2.36,0,0,0-.23-.35,1.62,1.62,0,0,0-.28-.25,1.2,1.2,0,0,0-.34-.17l-1.18-.4a4.46,4.46,0,0,0-.78.26,5.8,5.8,0,0,0-1.17.69.76.76,0,0,1-.35.46c-.13.08-.47.25-.47.25l-.07.05a11.88,11.88,0,0,0-1.07,1.17l-.22-.08a9.8,9.8,0,0,0-.87,1.21l.21.06c-.21.3-.41.6-.59.88l-.13-.05c-.25.44-.49.88-.76,1.3a34.81,34.81,0,0,0-2.73,5c-.18.57-.33,1.15-.48,1.73h0s0,0,0,.06-.11.47-.16.62c-.07.3-.16.58-.25.85s-.23,1-.35,1.37c1.67,1.07,3.34,2.15,5,3.26A20.07,20.07,0,0,0,217.68,208.93Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,214.49a2.49,2.49,0,0,1-.54-.89,5.44,5.44,0,0,1-.28-1.35,9.77,9.77,0,0,1,0-1.79,19.47,19.47,0,0,1,.34-2.24,28.57,28.57,0,0,1,1.56-4.81,33.25,33.25,0,0,1,2.43-4.67,25.76,25.76,0,0,1,2.85-3.77,10.93,10.93,0,0,1,2.77-2.26,3.68,3.68,0,0,1,.59-.26,2.78,2.78,0,0,1,.53-.14,1.81,1.81,0,0,1,.46,0,1.86,1.86,0,0,1,.41.08l-3.61-1.25a1.18,1.18,0,0,1-.6.18c-1.38.09-2.57,3-3.27,3.89a31.21,31.21,0,0,0-3.41,5.37,1.66,1.66,0,0,1,0,.22c-.68,2.36-1.77,4.44-2.29,6.9a12.75,12.75,0,0,0-.76,3.43,6.39,6.39,0,0,1,0,1.25l.08.09.22.18q1.4,1,2.76,2C210.88,214.52,210.86,214.51,210.85,214.49Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.08,217.45a3.4,3.4,0,0,1-.72-1.06,6.42,6.42,0,0,1-.41-1.65,12.44,12.44,0,0,1,0-2.24,20.28,20.28,0,0,1,.39-2.83,29.15,29.15,0,0,1,.77-3c.32-1,.7-2.08,1.14-3.13s.93-2.11,1.47-3.15,1.12-2,1.74-3,1.25-1.88,1.88-2.7a23.75,23.75,0,0,1,1.9-2.19,14.88,14.88,0,0,1,1.82-1.64,9.35,9.35,0,0,1,1.68-1.05,5.1,5.1,0,0,1,.66-.27,2.73,2.73,0,0,1,.6-.14,2,2,0,0,1,.54,0,1.62,1.62,0,0,1,.49.08l-3.39-1c-2-.63-3.89-1.3-5.83-2l-9.45,16.5L93.77,150.2c0,.2,0,.4,0,.6a10.45,10.45,0,0,0,.37,2.6,7.56,7.56,0,0,0,.9,2.06A6.4,6.4,0,0,0,96.36,157,6.85,6.85,0,0,0,98,158.05C112.05,164.15,167.75,185.76,209.08,217.45Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,133a7.82,7.82,0,0,0-2.7-.62,11.46,11.46,0,0,0-7.84,3.21,20.39,20.39,0,0,0-7.36,16.66c16.75,6.1,70.74,27.05,115.52,59.3A45.37,45.37,0,0,1,213,194.09c2.05-2.92,7.13-9.34,11.5-8.28C169.62,173.81,108.32,133.24,107.82,133Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.91,152.09c0,.07,0,.13,0,.19,16.75,6.1,70.74,27.05,115.52,59.3,0-.06,0-.12,0-.19C160.67,179.15,106.69,158.2,89.91,152.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,189.09c2.23-2.14,4.88-3.87,7.31-3.28l-1.09-.24C221.31,185.68,219.11,187.24,217.22,189.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,217.48a2.93,2.93,0,0,1-.73-1.06,5.85,5.85,0,0,1-.42-1.64,11,11,0,0,1,0-2.26,20.61,20.61,0,0,1,.39-2.84,28.49,28.49,0,0,1,.77-3c.32-1,.7-2.08,1.14-3.13s.93-2.12,1.47-3.16,1.12-2,1.74-3,1.25-1.87,1.89-2.69a25.3,25.3,0,0,1,1.89-2.2,15.62,15.62,0,0,1,1.82-1.63,8.9,8.9,0,0,1,1.68-1.06,4.33,4.33,0,0,1,1.36-.43,2.27,2.27,0,0,1,1.09.12,2,2,0,0,1,.8.62,3.2,3.2,0,0,1,.52,1.08,6.61,6.61,0,0,1,.22,1.44,13,13,0,0,1-.06,1.73c-.07.61-.17,1.27-.32,2s-.34,1.41-.56,2.17a36.81,36.81,0,0,1-1.65,4.4,42.5,42.5,0,0,1-2.15,4.2,35.7,35.7,0,0,1-2.48,3.71,18.87,18.87,0,0,1-2.65,2.84,7.74,7.74,0,0,1-1.21.85,3.85,3.85,0,0,1-1.08.43,2,2,0,0,1-.93,0,1.53,1.53,0,0,1-.74-.44,2.49,2.49,0,0,1-.54-.89,5.44,5.44,0,0,1-.28-1.35,9.77,9.77,0,0,1,0-1.79,19.47,19.47,0,0,1,.34-2.24,28.57,28.57,0,0,1,1.56-4.81,33.25,33.25,0,0,1,2.43-4.67,25.76,25.76,0,0,1,2.85-3.77,10.93,10.93,0,0,1,2.77-2.26,3.46,3.46,0,0,1,1.12-.4,1.67,1.67,0,0,1,.87.05,1.43,1.43,0,0,1,.65.44,2.2,2.2,0,0,1,.42.79,4.24,4.24,0,0,1,.2,1.09,7.66,7.66,0,0,1,0,1.35,15.07,15.07,0,0,1-.23,1.58c-.11.56-.26,1.16-.45,1.79a27.13,27.13,0,0,1-1.32,3.57,35.26,35.26,0,0,1-1.75,3.41,26,26,0,0,1-2,3,14.13,14.13,0,0,1-2.14,2.25,2.5,2.5,0,0,1,.07-.26,14.14,14.14,0,0,0,2.08-2.18,27.63,27.63,0,0,0,2-2.9,35.51,35.51,0,0,0,1.7-3.31,27,27,0,0,0,1.28-3.47c.18-.62.32-1.2.43-1.74a13.57,13.57,0,0,0,.22-1.54,9.58,9.58,0,0,0,0-1.3,4.9,4.9,0,0,0-.2-1,2.12,2.12,0,0,0-.42-.76,1.37,1.37,0,0,0-.63-.43,1.71,1.71,0,0,0-.85,0,3.47,3.47,0,0,0-1.08.39,10.83,10.83,0,0,0-2.69,2.21,24.59,24.59,0,0,0-2.75,3.66,32.89,32.89,0,0,0-2.36,4.53,26.84,26.84,0,0,0-1.51,4.66,18.52,18.52,0,0,0-.34,2.12,11.38,11.38,0,0,0,0,1.74,5.49,5.49,0,0,0,.26,1.34,2.47,2.47,0,0,0,.53.9,1.53,1.53,0,0,0,.74.44,1.87,1.87,0,0,0,.91,0,3.71,3.71,0,0,0,1-.42,8.77,8.77,0,0,0,1.15-.81,18,18,0,0,0,2.59-2.77,34,34,0,0,0,2.42-3.62,40.51,40.51,0,0,0,2.1-4.1,34.14,34.14,0,0,0,1.61-4.3c.22-.74.4-1.45.55-2.13a16.11,16.11,0,0,0,.3-1.92,9.77,9.77,0,0,0,.06-1.68,5.79,5.79,0,0,0-.22-1.41,3.05,3.05,0,0,0-.5-1,1.84,1.84,0,0,0-.79-.6,2.19,2.19,0,0,0-1.07-.11,4.26,4.26,0,0,0-1.33.43,12.77,12.77,0,0,0-3.47,2.71,30.68,30.68,0,0,0-3.62,4.7,40.91,40.91,0,0,0-3.08,5.92,33,33,0,0,0-1.92,6.06,20.87,20.87,0,0,0-.38,2.78,12.09,12.09,0,0,0,0,2.2,6.17,6.17,0,0,0,.41,1.62,3,3,0,0,0,.71,1,2,2,0,0,0,1,.46,2.63,2.63,0,0,0,1.17-.06,5.39,5.39,0,0,0,1.33-.59,10.66,10.66,0,0,0,1.49-1.1,23.79,23.79,0,0,0,3.21-3.52,45,45,0,0,0,3-4.5,54.44,54.44,0,0,0,2.59-5.05,46.3,46.3,0,0,0,2-5.3c.29-.95.53-1.86.71-2.71s.33-1.67.42-2.42a14.59,14.59,0,0,0,.1-2.13,8.49,8.49,0,0,0-.22-1.78,4.51,4.51,0,0,0-.56-1.37,2.48,2.48,0,0,0-2.25-1.16,5,5,0,0,0-1.73.41,15,15,0,0,0-4.51,3.29,36.62,36.62,0,0,0-4.8,6.07,49.72,49.72,0,0,0-4.08,7.8,39.71,39.71,0,0,0-2.42,8l-.25.16a40.89,40.89,0,0,1,2.46-8.13,50.21,50.21,0,0,1,4.18-8,37.35,37.35,0,0,1,4.9-6.2,15.16,15.16,0,0,1,4.61-3.33,4.88,4.88,0,0,1,1.76-.41,2.63,2.63,0,0,1,1.34.3,2.56,2.56,0,0,1,.94.91,4.37,4.37,0,0,1,.57,1.4,8.25,8.25,0,0,1,.22,1.82,15.22,15.22,0,0,1-.11,2.17c-.09.77-.23,1.59-.42,2.47s-.44,1.79-.74,2.75a48,48,0,0,1-2,5.4,52.76,52.76,0,0,1-2.63,5.14,45.63,45.63,0,0,1-3,4.59,24.73,24.73,0,0,1-3.27,3.59,11,11,0,0,1-1.52,1.13,5.73,5.73,0,0,1-1.37.61,2.74,2.74,0,0,1-1.19.08A2.17,2.17,0,0,1,209.1,217.48Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,166.21c-4.66-2.14-9.64-4.52-14-6.69-7.44,1-12.11,14.5-10.41,19.06,4.26,2.08,8.36,4.14,12.84,6.47C155.59,180.37,160.55,166.4,168.59,166.21Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,166.12c-4.58-2.1-9-4.24-13.3-6.36-7.92-.2-13,14.33-11.05,18.75,4.13,2,8.38,4.14,12.71,6.4C155,180.79,159.73,165.46,168.39,166.12Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42,178.3a9.53,9.53,0,0,1-.09-2c0-.54.23-1.71.23-1.73s-3.45,2.48-4.68,2.18c-1.81-.43-4.49-5.69-4.49-5.69a11.31,11.31,0,0,0-.13,1.83,8.08,8.08,0,0,0,.39,1.94c.09.25.2.5.32.76q4.35,2.06,8.93,4.32A6.32,6.32,0,0,1,146.42,178.3Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.83,164.94c-3.6-1.68-7.34-3.49-10.74-5.18-7.92-.2-13,14.33-11.05,18.75,3.23,1.57,6.56,3.25,9.92,5C151.63,179.61,156.33,163.46,165.83,164.94Z",
    style: {
      fill: "#45097f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,158.62c-9.34-2.25-15.23,17-11.13,19s7.25,3.51,11.55,5.69c.06,0,.32,0,.38.08s-.3-.11-.34-.17c-2-3.21,2.16-21.06,12.35-18.43Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,180.1a5.88,5.88,0,0,1-.56-1.8,9.53,9.53,0,0,1-.09-2c0-.54.23-1.71.23-1.73s-3.45,2.48-4.68,2.18a2.68,2.68,0,0,1-1.07-.67,2.31,2.31,0,0,0,1.1,1.57l.56.28C144.06,178.68,145.52,179.39,147,180.1Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,182.62a5.08,5.08,0,0,1-3.66.51c-2.43-1.06-7.07-3.37-9.18-4.33a6,6,0,0,1-2.5-2.16,10,10,0,0,1-1.38-3.09,15.28,15.28,0,0,1-.49-2.86c0-.45-.21-1-.21-1.18s.17-.1.17-.11,3.29,6.1,5.36,6.55c1.4.3,5.13-2.56,5.13-2.56s-.07.55-.09,1.37a18,18,0,0,0,.14,3,9.9,9.9,0,0,0,.87,3.12C146.58,181.75,147.7,184.12,152,182.62Z",
    style: {
      fill: "#a051e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,183,139,178.91a6.14,6.14,0,0,1-2.51-2.16,10.12,10.12,0,0,1-1.37-3.09,15.28,15.28,0,0,1-.49-2.86,12.22,12.22,0,0,1,0-1.29s3.29,6.1,5.36,6.54c1.4.31,5.13-2.55,5.13-2.55s-.07.56-.09,1.37a19,19,0,0,0,.13,3A10.19,10.19,0,0,0,146,181,4.11,4.11,0,0,0,147.87,183Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.49,297.34a210.28,210.28,0,0,0-25.35,1.52v3.8a210.77,210.77,0,0,1,50.7,0v-3.8A213.08,213.08,0,0,0,296.49,297.34Z",
    style: {
      fill: "url(#radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66,282.54s-1.15-11.5,0-16.32c0,0-7.86,12.57-9.74,18.45,0,0-6-20.6-8.44-30.1C294,265,288,284.67,288,284.67c-1.88-5.88-9.73-18.45-9.73-18.45,1.15,4.82,0,16.32,0,16.32-5-8-18.38-19.05-18.38-19.05a100.56,100.56,0,0,1,11.21,33.85,181.47,181.47,0,0,1,50.71,0,99.64,99.64,0,0,1,9.29-33.85S319.66,274.5,314.66,282.54Zm-41,11.31-4.61-16.7A66.56,66.56,0,0,1,276,287.26,23.05,23.05,0,0,0,273.68,293.85Zm9.86-1.08a28.19,28.19,0,0,0-3.66-5.7,31.65,31.65,0,0,0,1.27-10.63s3.66,7.59,4.54,9.87C285.69,286.31,283.63,290.87,283.54,292.77Zm12.95,0a36.23,36.23,0,0,0-5.07-6.65,79.4,79.4,0,0,0,3.1-10.5c1.27-5.83,2-10.46,2-10.46s.7,4.63,2,10.46a78.48,78.48,0,0,0,3.11,10.5A36,36,0,0,0,296.49,292.77Zm12.95,0c-.08-1.9-2.15-6.46-2.15-6.46.88-2.28,4.54-9.87,4.54-9.87a32,32,0,0,0,1.27,10.63A28.7,28.7,0,0,0,309.44,292.77Zm9.87,1.08a23.25,23.25,0,0,0-2.32-6.59,66.19,66.19,0,0,1,6.93-10.11Z",
    style: {
      fill: "url(#radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.74,250.36a8.19,8.19,0,0,1-2.25-3.4,8.06,8.06,0,0,1-2.25,3.4,6.48,6.48,0,0,1,2.24,3.36v.06s0,0,0,0,0,0,0,0v-.06A6.54,6.54,0,0,1,298.74,250.36Z",
    style: {
      fill: "url(#radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91,263.22a6.19,6.19,0,0,1-.73-3.33,8.86,8.86,0,0,1-3.06,2.35,4.92,4.92,0,0,1,.74,3.3l0,.06s0,0,0,0a.08.08,0,0,1,0,0l0-.06A7.11,7.11,0,0,1,317.91,263.22Z",
    style: {
      fill: "url(#radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.69,261a6.07,6.07,0,0,1-.1-3.37,9.77,9.77,0,0,1-3.46,2,4.81,4.81,0,0,1,.12,3.36l0,.05,0,0a0,0,0,0,0,0,0l0-.05A7.82,7.82,0,0,1,334.69,261Z",
    style: {
      fill: "url(#radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.05,263.22a6.26,6.26,0,0,0,.74-3.33,8.77,8.77,0,0,0,3,2.35,5,5,0,0,0-.73,3.3l0,.06s0,0,0,0v0l0-.06A7.17,7.17,0,0,0,275.05,263.22Z",
    style: {
      fill: "url(#radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,261a6.19,6.19,0,0,0,.1-3.37,9.78,9.78,0,0,0,3.45,2,4.81,4.81,0,0,0-.12,3.36l0,.05,0,0v0l0-.05A7.76,7.76,0,0,0,258.28,261Z",
    style: {
      fill: "url(#radial-gradient-24)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinning01);
export default __webpack_public_path__ + "static/media/winning-01.2b5523fb99d273d1273fda77bcf0e4c3.svg";
export { ForwardRef as ReactComponent };